export default __webpack_public_path__ + "static/media/check.43b13334.png";